import { createRecipe } from './runtime';

const tileConfig = {"name":"tile","defaultVariants":{"tone":"sky"},"variantMap":{"interactive":["true"],"tone":["blush","cobalt","leaf","sky","sun","tomato"]}}

export const tile = /* @__PURE__ */ createRecipe(tileConfig)